// A key that opens the kit Popover hung off itself, with the content as a render prop that is
// handed `close`. The pulls pages sit their keys inside table rows, so the key's click stays
// its own and never reaches the row.

import React, { useRef, useState } from 'react';
import { Popover } from '../../components/ui/Popover';
import Tooltip from '../../components/ui/Tooltip';

interface Props {
  triggerLabel: React.ReactNode;
  triggerClassName: string;
  triggerAriaLabel?: string;
  /** Hover text saying what happens. */
  tooltip?: string;
  title: string;
  disabled?: boolean;
  align?: 'start' | 'end';
  width?: 'sm' | 'md' | 'lg';
  onOpen?: () => void;
  children: (close: () => void) => React.ReactNode;
}

const KeyPopover: React.FC<Props> = ({
  triggerLabel,
  triggerClassName,
  triggerAriaLabel,
  tooltip,
  title,
  disabled,
  align = 'start',
  width = 'md',
  onOpen,
  children,
}) => {
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  const close = () => setOpen(false);

  return (
    <>
      <Tooltip label={tooltip ?? ''}>
        <button
          ref={trigger}
          type="button"
          disabled={disabled}
          aria-label={triggerAriaLabel}
          aria-expanded={open}
          onClick={(e) => {
            e.stopPropagation();
            if (open) {
              close();
            } else {
              setOpen(true);
              onOpen?.();
            }
          }}
          className={triggerClassName}
        >
          {triggerLabel}
        </button>
      </Tooltip>
      <Popover
        open={open}
        onClose={close}
        anchor={trigger}
        returnTo={trigger}
        title={title}
        align={align}
        width={width}
        hideClose
        aboveDrawer
      >
        {children(close)}
      </Popover>
    </>
  );
};

export default KeyPopover;
